module.exports = __webpack_public_path__ + "img/gdgn.98def60e.png";